import dayjs from "dayjs";
import { useDatetime } from "../../../../../utils/useDatetime";
import { useSessionContext } from "../../../../../contexts/SessionContext";
import { CarePlanActions } from "./CarePlanActions";
import { EhrMobileGenericSection } from "../../mobile/EhrMobileGenericSection";

export function CarePlan({
  data,
  title,
  openVisualizer,
  verifyVisualizer,
}: any) {
  const { access } = useSessionContext();
  const { formatToDDMMYYYY } = useDatetime;

  const columns = [
    { column: "Plano", rowName: "plan" },
    { column: "Data", rowName: "date" },
    { column: "Profissional", rowName: "professional" },
  ];

  const rowData = data?.[0]?.entry?.map((el: any) => ({
    encounterId: el?.resource?.encounter?.reference?.split("/")?.[1],
    plan: el?.resource?.description || "-",
    date: formatToDDMMYYYY(dayjs(el?.resource?.created)),
    professional: el?.resource?.contributor?.[0]?.display || "-",
    fullResource: el?.resource,
  }));

  return (
    <EhrMobileGenericSection
      title={title}
      columns={columns}
      rows={rowData ?? []}
      actions={
        access?.type === "patient"
          ? undefined
          : (rowData: any) => (
              <CarePlanActions
                row={rowData}
                openVisualizer={openVisualizer}
                verifyVisualizer={verifyVisualizer}
              />
            )
      }
    />
  );
}
